import * as API from "../";

export default {
  list: (params) => {
    return API.postJsonRequest("/api/device/blue/list", params);
  },
  noBingList: (params) => {
    return API.postJsonRequest("/api/device/blue/nobind/list", params);
  },
  addDevice: (method, params) => {
    return API.postJsonRequest("/api/device/blue/add/" + method, params);
  },
  delete: (params) => {
    return API.DELETE("/api/device/blue/delete/" + params);
  }
};



// WEBPACK FOOTER //
// ./src/api/blue/api_device.js